/**
 * 라우트 정의와 정규화.
 *
 * 알려진 경로 4개만 존재하고 나머지는 전부 갤러리로 접습니다 — 컨테이너의 Node 서버가 SPA
 * fallback 으로 모든 경로에 셸을 돌려주므로(`server.js`) 오타 URL 도 앱까지 도달합니다.
 */

import { currentPath } from "./nav";

export const ROUTES = ["/login", "/gallery", "/members", "/sites"] as const;

export type Route = (typeof ROUTES)[number];

const isRoute = (path: string): path is Route => (ROUTES as readonly string[]).includes(path);

/**
 * currentRoute 는 현재 경로를 알려진 화면으로 정규화합니다.
 *
 * 콘솔 루트(`/`)는 **로그인 진입**이라 `/login` 으로 접습니다 — 세션이 있으면 App 이 다시
 * 갤러리로 정규화하므로, 로그인한 사람이 루트를 열면 갤러리를 봅니다.
 */
export function currentRoute(): Route {
  const path = currentPath().replace(/\/+$/, "");
  if (path === "") return "/login";
  return isRoute(path) ? path : "/gallery";
}
